import api from "./axios";

export default class ProductsService {
  addProduct = async (productId: number) => {
    return api.post("/api/ems/add-product", { productId });
  };

  removeProduct = async (productId: number) => {
    return await api.post("/api/ems/remove-product", {
      productId: productId,
    });
  };
}
